import api from 'config/api';

export default {
  getPaymentSurvey: async () => api.get('api/v1/utilities/payment_survey_form'),
  getProcedureSurvey: async () => api.get('api/v1/utilities/procedure_survey_form')
};
